// Copyright (c) 2016 Deere & Company

export const buildFilePath = file =>
    `/api/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}`;

export const getFileUploadErrorMessage = error =>
    (typeof error === 'string' && error.includes('File is too big')) ? 'FILE_SIZE_IS_TOO_BIG' : 'ERROR_UPLOADING_FILE';

export const getFileUploadCsvErrorMessage = error =>
    (typeof error === 'string' && error.includes('File is too big')) ? 'FILE_SIZE_IS_TOO_BIG_CSV' : 'ERROR_UPLOADING_FILE';



// WEBPACK FOOTER //
// ./src/shared/services/file-service.js